import React, { useEffect, useState } from "react";
import ImageUploaderWrapper from "./ImageUploaderWrapper";
import ColorSchemeCreation from "./ColorSchemeCreation";
import { performPostRequest } from "../../../service/network/NetworkService";
import { getApiUrl } from "../../../service/network/UrlMapper";
import IntentType from "../../../intentexecutor/utils/IntentType";
import ErrorNotificationComponent from "../../../components/generic/error/ErrorNotificationComponent";
import AddTitle from "./AddTitle";

const ThemeCreator = ({ organizationIdentifier }) => {
  const [theme, setTheme] = useState(null);

  useEffect(() => {
    const getTheme = async () => {
      try {
        const payload = {
          intent: "get_configuration",
          payload: {
            configurationKey: ["niramaya.organization.theme"],
          },
          context: {
            organizationIdentifier,
          },
        };
        const result = await performPostRequest(
          getApiUrl()[IntentType.GET_CONFIGURATION],
          JSON.stringify(payload)
        );
        const response = await result.json();
        const themeValue = JSON.parse(response[0].configurationValue);
        setTheme(themeValue);
      } catch (err) {
        ErrorNotificationComponent(err);
      }
    };

    getTheme();
  }, [organizationIdentifier]);

  return (
    <>
      <AddTitle
        theme={theme}
        setTheme={setTheme}
        organizationIdentifier={organizationIdentifier}
      />
      <ImageUploaderWrapper
        theme={theme}
        setTheme={setTheme}
        organizationIdentifier={organizationIdentifier}
      />
      <ColorSchemeCreation
        theme={theme}
        setTheme={setTheme}
        organizationIdentifier={organizationIdentifier}
      />
    </>
  );
};

export default ThemeCreator;
